// tslint:disable
export var CampaignType;
(function (CampaignType) {
    // UNKN
    CampaignType[CampaignType["UNKN"] = 10001] = "UNKN";
    // MULMED
    CampaignType[CampaignType["MULMED"] = 10002] = "MULMED";
    // ADHER
    CampaignType[CampaignType["ADHER"] = 10003] = "ADHER";
    // SOV
    CampaignType[CampaignType["SOV"] = 10004] = "SOV";
    // EDBF
    CampaignType[CampaignType["EDBF"] = 10006] = "EDBF";
})(CampaignType || (CampaignType = {}));
//# sourceMappingURL=CampaignType.js.map